import graphql from 'babel-plugin-relay/macro';
import createMutation from '../../helpers/createMutation';

const mutation = graphql`
  mutation ActionCancelReservationMutation($input: Action__CancelReservationInput!) {
    actionCancelReservation(input: $input) {
        entity { 
          id
          dbId
          availability
          entityStates {
            id
            dbId
            state
            dueDate
            userId
          }
        }
        error
    }
  }
`;

const commit = input =>
    createMutation({
        mutation,

        variables: {
            input
        }
    });
//
// const commit = (input, onCompleted, onError) =>
//     createMutation({
//         mutation,
//         variables: {
//             input
//         },
//         updater: store => {
//             const payload = store.getRootField('actionCancelReservation');
//             if (!payload) return;
//
//             const updatedEntity = payload.getLinkedRecord('entity');
//             if (!updatedEntity) return;
//
//             // Get entity ID and update it in the store
//             const entityId = updatedEntity.getValue('id'); // Relay Global ID
//             const entityRecord = store.get(entityId);
//             if (!entityRecord) return;
//
//             // Update entity fields in the store
//             entityRecord.setValue(updatedEntity.getValue('availability'), 'availability');
//             entityRecord.setValue(updatedEntity.getValue('visibility'), 'visibility');
//
//             // Update entity states
//             const updatedStates = updatedEntity.getLinkedRecords('entityStates');
//             entityRecord.setLinkedRecords(updatedStates, 'entityStates');
//         },
//         onCompleted,
//         onError
//     });

export default { commit };
